module.exports = __webpack_public_path__ + "static/media/oct.68633a04.jpg";